export default __webpack_public_path__ + "static/media/creative_art.f2d0db03.svg";